const maskUnits = (
  value: string | number | null,
  units?: Unit,
  fractionDigits?: number
): string => {
  const fractionDigitsDefault = 0;
  if (value === null || value === undefined) return "";
  if (typeof value === "string") {
    value = Number(value);
  }
  if (!units)
    return value.toFixed(fractionDigits ?? fractionDigitsDefault) + "";

  const unit = units.toLowerCase();
  //essa funcao pega o value e se o unit for igual a "%" ele retorna o valor com a mascara de porcentagem e nenhuma casa decimal
  if (unit === "%") {
    return value.toLocaleString("en-IN", {
      style: "percent",
      minimumFractionDigits: fractionDigits ?? fractionDigitsDefault,
      maximumFractionDigits: fractionDigits ?? fractionDigitsDefault,
    });
  }
  //essa funcao pega o value e se o unit for igual a "R$" ele retorna o valor com a mascara de real e duas casas decimais
  if (unit === "r$") {
    // essa funcao tbm converte para unidades de medida financeiras k, Mi, Bi
    const divisor =
      value >= 1e9 ? 1e9 : value >= 1e6 ? 1e6 : value >= 1e3 ? 1e3 : 1;
    value = value / divisor;
    const unit =
      divisor === 1e9
        ? "Bi"
        : divisor === 1e6
        ? "Mi"
        : divisor === 1e3
        ? "k"
        : "";
    //retorna na unidade de medida inglesa
    return (
      "R$" +
      value.toLocaleString("en-IN", {
        // style: "currency",
        // currency: "BRL",
        minimumFractionDigits: fractionDigits ?? fractionDigitsDefault,
        maximumFractionDigits: fractionDigits ?? fractionDigitsDefault,
      }) +
      unit
    );
  }

  return value.toFixed(fractionDigits ?? fractionDigitsDefault) + "" + units;
};
export default maskUnits;
